import React from "react";
import CardClasses from "./Cards.module.css";
import Icon1 from "Assets/contact/icon_1.png";
import Icon2 from "Assets/contact/icon_2.png";
import Icon3 from "Assets/contact/icon_3.png";

const Card = [
    {
        icon: Icon1,
        Content: "",
        heading: "",
    },
    {
        icon: Icon2,
        Content: "",
        heading: "",
    },
    {
        icon: Icon3,
        Content: "",
        heading: "You need it? We provide it",
    },
];

function Cards() {
    return (
        <div className={CardClasses["Container"]}>
            <div className={CardClasses["Cards-wrapper"]}>
                <div className={CardClasses["card"]}>
                    {/* <div className={CardClasses["icon-wrapper"]}>
                    </div> */}
                    <img src={Icon1} />
                    <h3>Office Address</h3>
                    <p>42707 Wardlaw Ter Ashburn Virginia 20147,USA.</p>
                </div>
                <div className={CardClasses["card"]}>
                    {/* <div className={CardClasses["icon-wrapper"]}>
                    </div> */}
                    <img src={Icon2} />
                    <h3>Telephone</h3>
                    <p>
                        +262-735-8874,
                        <br />
                        +262-735-8875
                    </p>
                </div>
                <div className={CardClasses["card"]}>
                    {/* <div className={CardClasses["icon-wrapper"]}>
                    </div> */}
                    <img src={Icon1} />
                    <h3>Mail Us</h3>
                    <p>
                        contact@serenetax.com,
                        <br />
                        info@serenetax.com
                    </p>
                </div>
            </div>
        </div>
    );
}

export default Cards;
